export default "__VITE_ASSET__CYJ7imnJ__"